//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export enum PROMOTED_POSTS_ELIGIBILITY_STATES {
  FETCHING = 'FETCHING',
  PROMOTION_RUNNING = 'PROMOTION_RUNNING',
  ELIGIBLE = 'ELIGIBLE',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  GALLERY = 'GALLERY',
}

export const PROMOTED_POSTS_IMAGE_REQUIREMENTS = {
  MIN_HEIGHT: 315,
  MIN_WIDTH: 600,
};

export const PROMOTED_POSTS_ITEM_TYPES = {
  GALLERY: 'GALLERY',
  POST: 'POST',
};

export const PROMOTED_POSTS_MEDIA_TYPES = {
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE',
};
